import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {
  formatTypePiecePourDemande,
  shouldDisplayFonctionnalite,
} from '../../../../components/helpers'
import {ModeleClientDemande} from '../../../../components/Models'
import {SelectInput} from '../../../../components/inputs/SelectInput'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {Link, useParams} from 'react-router-dom'
import {ShopModal} from './shop/ShopModal'
import PieceStatus from './Televendeur/PieceStatus'
import {Tooltip} from 'react-tooltip'
import {getDemandeProposee} from '../../../../components/requests'
import ModalPOT from './Televendeur/ModalPOT'
import {useFilAriane} from '../../../contexts/FilArianeContext'

const clientDemandeSchema = Yup.object().shape({
  commentaire: Yup.string().notRequired(),
})

const ListePiece = (props: any) => {
  const {
    immatsArray,
    pieces,
    setPieces,
    isAssign,
    piecesProps,
    setPiecesProps,
    panier,
    setPanier,
    data,
    setDemandeClient,
    redirectToClientDemande,
    dataClientInfos,
    otherData,
    loadingCLientInfo,
    isProspect,
    showToastPOT,
    isFromPOT,
    isFromClient,
    clientAdresses,
    demandeClient,
    filters,
    panierByStatus,
    setPanierByStatus,
    fromListePiece,
    setFromListePiece,
    provenances,
    isLoadingProvenance,
    updatedAdresseLivInfo,
    setUpdatedAdresseLivInfo,
    setUpdatedAdresseFactInfo,
    updatedAdresseFactInfo,
    updatedFinalAdresseLivInfo,
    setUpdatedFinalAdresseLivInfo,
    updatedFinalAdresseFactInfo,
    setUpdatedFinalAdresseFactInfo,
    isAdresseUpdated,
    setIsAdresseUpdated,
    adresseFacturation,
    errorsFac,
    errorsLiv,
    setErrorsLIv,
    setErrorsFac,
    requierdFieldFac,
    requierdFieldLiv,
    contactedByBloc,
    setContactedByBloc,
    clientDemandeStatus,
    piecePropData,
    searchTerm,
    setSearchTerm,
    refetchClientAdresses,
    retraitDepot,
    setRetraitDepot,
    getObjetOfCheckedPiece,
    totalLibelle,
    setTotalLibelle,
    getAdresseRetraitDepot = () => {},
    setSelectedDepotsByPiece = () => {},
    loadingDepot,
    adresseDepots,
    initialPieces,
    setInitialPieces,
    commentaireInterne,
    setCommentaireInterne,
    sourceDevis,
    livraisonSelectedValue,
    setLivraisonSelectedValue,
    facturationSelectedValue,
    setFacturationSelectedValue,
    clientAdresseData,
    clientContacts,
    imagesDemandePj,
    currentUser
  } = props
  const [immatSelected, setImmatSelected] = useState('Tous')
  const [loading, setLoading] = useState(false)
  const [panierFiltered, setPanierFiltered] = useState(panier)
  const params = useParams()
  const demandeId = Number(params?.demandId)
  const [selectedPiece, setSelectedPiece] = useState<any | null>(null)
  const [selectedSite, setSelectedSite] = useState<any | null>(null)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const {selectedPOTAriane} = useFilAriane()

  const [isEditPanier, setIsEditPanier] = useState<boolean>(false)

  const handleChangeImmatSel = (e: any) => {
    setImmatSelected(e.target.value)
    setSelectedPiece(e.target.value)
    setSelectedSite(immatsArray?.find((item) => item?.value === e.target.value)?.site ?? null)
  }

  const formik = useFormik<ModeleClientDemande>({
    initialValues: data,
    validationSchema: clientDemandeSchema,
    onSubmit: (values: ModeleClientDemande) => {
      console.log(values)
    },
  })

  const getDemandeProp = useCallback(() => {
    setLoading(true)
    getDemandeProposee(demandeId).then((clientDemandeProp) => {
      if (clientDemandeProp?.status == 200 && clientDemandeProp?.data != undefined) {
        const finalPanier = clientDemandeProp?.data?.map((piece) => {
          // TVA POT toujours 20%
          const isProfessionnel = piece?.isTypePiecePOT
            ? 20
            : dataClientInfos && dataClientInfos?.professionnel === false
            ? 10
            : 20

          const pieceExclue = !!dataClientInfos?.sauf?.some(
            (item) => item.label === piece.nomTypePieceProposee
          )
          const fraisOffert = !!dataClientInfos?.fraisPortOffert && !pieceExclue
          const fraisDePort = fraisOffert || retraitDepot ? 0 : Number(piece?.fraisDePort)

          const taux = Number(piece?.tauxRemise ?? 0)
          const tauxTva = Number(piece?.tauxTva ?? 0)
          const prix = Number(piece.prix ?? 0)

          const prixReferentielTtc = Number(prix * (1 + tauxTva / 100)) ?? 0
          const prixReferentielHtInitial = piece?.isTypePiecePOT
            ? Number(piece?.prixReferentiel) ?? 0
            : Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ?? 0
          const prixReferentielHt =
            Number(piece?.prixReferentiel) ??
            Number(prixReferentielTtc / (1 + isProfessionnel / 100)) ??
            0

          const prixVenteProposeeHt =
            Number(prixReferentielHt - prixReferentielHt * (taux / 100)) ?? 0
          const prixVenteProposeeTtc =
            Number(prixVenteProposeeHt * (1 + isProfessionnel / 100)) ?? 0
          const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

          return {
            ...piece,
            tauxRemise: Number(taux?.toFixed(1)),
            fraisDePort: Number(fraisDePort?.toFixed(2)),
            montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
            prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
            prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
            prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
            prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
            prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
          }
        })
        setPanier(finalPanier)
        setPanierFiltered(finalPanier)

        if (finalPanier && initialPieces.length === 0) {
          const copieInitiale = finalPanier
            .filter((p) => p.statut === 'PROPO')
            .map((p) => {
              return {
                id: p.id,
                tauxRemise: Number(p?.tauxRemise ?? 0),
                montantRemise: Number(p?.montantRemise ?? 0),
                fraisDePort: Number(p.fraisDePort ?? 0),
                fraisDePortInitial: Number(p.fraisDePort ?? 0),
                prixReferentielHt: Number(p?.prixReferentielHt ?? 0),
                prixReferentielTtc: Number(p?.prixReferentielTtc ?? 0),
                prixVenteProposeeHt: Number(p?.prixVenteProposeeHt ?? 0),
                prixVenteProposeeTtc: Number(p?.prixVenteProposeeTtc ?? 0),
              }
            })
          setInitialPieces(copieInitiale)
        }
        setLoading(false)
      }
    })
  }, [demandeId])

  useEffect(() => {
    if (demandeId && dataClientInfos) {
      getDemandeProp()
    }
  }, [demandeId, dataClientInfos])

  const handleSetPieceId = (idTypePiece: any, marque: string, modele: string, idPiece: any) => {
    const filtered = panier.filter((p) => {
      // return p.idTypePiece === idTypePiece && p.marque === marque && p.modele === modele
      return p.idCLientDemandePiece === idPiece //&& p.statut !== 'A_PROPO'
    })
    // console.log('filtered' ,filtered)
    setFromListePiece(true)
    setPanierFiltered(filtered)
    setPanierByStatus(filtered)
  }

  useEffect(() => {
    setPanierFiltered(panier)
    renderFormRowPieces()
  }, [panier, setPanier])

  const handleDismiss = () => {
    setPanierFiltered(panier)
    setFromListePiece(false)
  }

  const handlePanierFiltered = (newPanier) => {
    setPanierFiltered(newPanier)
  }

  const selectedPiecesFromVehicle = useMemo(() => {
    return pieces
      .filter(
        (piece: any) =>
          piece.clientDemandeImmat?.immatriculation === immatSelected ||
          (piece.clientDemandeImmat?.modele &&
            `${piece.clientDemandeImmat.modele.marque?.nom} - ${piece.clientDemandeImmat.modele.nom}` ===
              immatSelected) ||
          (piece.clientDemandeImmat?.vehiculeHorsType &&
            `${piece.clientDemandeImmat.vehiculeHorsType.marque} - ${piece.clientDemandeImmat.vehiculeHorsType.nom} [VHT]` ===
              immatSelected)
      )
      .map((piece: any) => {
        return piece
      })
  }, [pieces, immatSelected])

  useEffect(() => {
    // Sélectionne de la première immat
    if (immatsArray.length == 1) {
      setImmatSelected(immatsArray[0]?.value)
    }
  }, [immatSelected, immatsArray])

  const renderFormRowPieces = () => {
    return pieces
      .filter(
        (piece: any) =>
          immatSelected === 'Tous' ||
          piece.clientDemandeImmat?.immatriculation === immatSelected ||
          (piece.clientDemandeImmat?.modele &&
            piece?.clientDemandeImmat?.modele?.marque?.nom +
              ' - ' +
              piece?.clientDemandeImmat?.modele?.nom ===
              immatSelected) ||
          (piece.clientDemandeImmat?.vehiculeHorsType &&
            piece?.clientDemandeImmat?.vehiculeHorsType?.marque +
              ' - ' +
              piece?.clientDemandeImmat?.vehiculeHorsType?.nom +
              ' [VHT]' ===
              immatSelected)
      )
      .map((piece: any, index: number) => {
        let aValider = panier?.some(
          (item: any) =>
            item.idCLientDemandePiece === piece?.id &&
            item.statut === 'A_PROPO' &&
            piece?.clientDemandePieceProposee?.length > 0
        )
        const isVht = piece.clientDemandeImmat?.vehiculeHorsType ? ' [VHT]' : ''
        const isTypePiecePOT = piece?.typePiecePOT?.length > 0
        const isDemandeDemontage = piece?.demandeDemontage ?? false

        let backgroundColor = ''
        if (isTypePiecePOT) {
          backgroundColor = '#fffce6'
        } else if (isDemandeDemontage) {
          backgroundColor = '#e6ffed'
        }
        return (
          <tr key={index} style={{backgroundColor: backgroundColor}}>
            <td>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece.id !== undefined && piece.id !== null
                  ? [
                      piece.typePiece !== undefined &&
                      piece.typePiece !== null &&
                      piece.typePiece?.id !== undefined
                        ? formatTypePiecePourDemande(piece.typePiece)
                        : piece?.typePieceHn
                        ? '[999999] - ' + piece.typePieceHn
                        : piece.referenceManuelle,
                    ]
                  : piece.typePiece.code}
              </p>
            </td>
            <td>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece?.clientDemandeImmat?.immatriculationNonTrouvee
                  ? piece?.clientDemandeImmat?.immatriculationNonTrouvee + ' [NT]'
                  : piece.clientDemandeImmat?.immatriculation}
              </p>
            </td>
            <td>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece?.marque} / {piece?.modele} {isVht}
              </p>
            </td>
            <td className='min-w-500px'>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                <textarea
                  className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                  name={'commentaire' + index}
                  placeholder={'Commentaire'}
                  disabled={true}
                  value={piece.commentaire}
                  style={{maxHeight: '170px'}}
                ></textarea>
              </p>
            </td>
            <td className='min-w-500px'>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                <input
                  type={'text'}
                  className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                  name={'refOE' + index}
                  placeholder={'Référence OE'}
                  disabled={true}
                  value={piece.referenceConstructeur || piece.refConst || ''}
                />
              </p>
            </td>
            <td>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece.quantite}
              </p>
            </td>
            <td>
              {!piece?.dateCloture || piece?.dateCloture === '' ? (
                <span
                  key={piece.id}
                  className='d-flex flex-column gap-2 cursor-pointer'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_1'
                  data-tooltip-id='tooltip'
                  data-tooltip-content='Voir le(s) proposition(s)'
                  data-tooltip-place='left'
                  onClick={(e: any) =>
                    handleSetPieceId(piece.typePiece?.id, piece.marque, piece.modele, piece.id)
                  }
                >
                  <PieceStatus piece={piece} demandeClient={demandeClient} />
                </span>
              ) : (
                <span className='badge bg-info text-white'>Non disponible</span>
              )}
            </td>
            <td className='text-end'>
              <p className='text-gray-700 fw-bold text-hover-primary d-block fs-6 mb-0'>
                {piece.stock === 'chargement' ? (
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                ) : (
                  piece.stock
                )}
              </p>
            </td>
          </tr>
        )
      })
  }

  return (
    <>
      <div className='row gap-3'>
        <div className='d-flex justify-content-between'>
          <div className='col-3'>
            <SelectInput
              fieldName={''}
              inputClassName={'form-select form-select-solid form-select-lg fw-bold'}
              options={
                immatsArray.length > 1
                  ? [{value: 'Tous', label: 'Tous'}, ...immatsArray]
                  : immatsArray.length === 1
                  ? immatsArray
                  : [{value: 'Tous', label: 'Tous'}]
              }
              formik={formik}
              onChange={(e: any) => handleChangeImmatSel(e)}
            />
          </div>
          <div className='d-flex gap-6'>
            {shouldDisplayFonctionnalite(currentUser, 'TRAITER DEMANDE') && (
              <>
                {/*bouton désactivé si l'information du client se charge ou le véhicule séléctionné est sur Tous*/}
                {isAssign && (
                  <Link
                    to={`/demandes/${selectedPiecesFromVehicle[0]?.clientDemandeImmat.id}/enStock`}
                    className={`btn d-flex gap-4 align-items-center ${
                      immatSelected === 'Tous' || loadingCLientInfo || isLoadingProvenance
                        ? 'btn-light disabled'
                        : ' btn-light-info'
                    }`}
                    state={{
                      selectedPiecesFromVehicle,
                      redirectToClientDemande: redirectToClientDemande,
                      pieces: pieces,
                      isProspect: isProspect,
                      clientId: params?.clientId,
                      demandeImmatId: pieces[0].clientDemandeImmat?.id,
                      demandeId: pieces[0].demande?.id,
                      isHorsType:
                        !!selectedPiecesFromVehicle[0]?.clientDemandeImmat?.vehiculeHorsType?.id,
                      immatriculation: pieces[0].clientDemandeImmat.modele
                        ? pieces[0].clientDemandeImmat.modele.id
                        : pieces[0].clientDemandeImmat?.vehiculeHorsType
                        ? pieces[0].clientDemandeImmat?.vehiculeHorsType.id
                        : pieces[0].clientDemandeImmat?.immatriculation,
                      immat: pieces[0].clientDemandeImmat?.immatriculation,
                      quantity: pieces[0]?.quantite - (pieces[0]?.proposee ?? 0),
                      refConst: pieces[0].referenceConstructeur,
                      marque: pieces[0].marque,
                      modele: pieces[0].modele,
                      pieceQuantity: pieces[0]?.quantite,
                      idModele: pieces[0]?.clientDemandeImmat?.modele?.id,
                      isViaModele: !!pieces[0]?.clientDemandeImmat?.modele?.id,
                      idPiecePropose: pieces[0]?.id,
                      dataClientInfos: dataClientInfos,
                      otherData: otherData,
                      // loadingCLientInfo: loadingCLientInfo,
                      idDemandePiece: selectedPiecesFromVehicle[0]?.id,
                      // Pour les données à envoyer pour la recherche IA
                      dataVehicle: pieces[0].clientDemandeImmat.modele
                        ? pieces[0].clientDemandeImmat.modele
                        : pieces[0].clientDemandeImmat?.vehiculeHorsType ??
                          pieces[0].clientDemandeImmat?.donneesImmatriculation,
                      natVehicle: pieces[0].clientDemandeImmat.modele
                        ? 'modele'
                        : pieces[0].clientDemandeImmat?.vehiculeHorsType
                        ? 'VHT'
                        : 'immatriculation',
                      nomTP: pieces[0].typePiece?.nom,
                      piece: pieces[0],
                      isFromPOT: isFromPOT,
                      isFromClient: isFromClient,
                      isAssign: isAssign,
                      isAvailable:
                        (selectedPiecesFromVehicle ?? pieces)?.[0]?.statut !== 'NON_DISPONIBLE',
                      isHorsNomenclature: !pieces[0].typePiece?.id,
                      clientAdresses: clientAdresses,
                      demandeClient: demandeClient,
                      filters: filters,
                      fromListePieceStock: true,
                      provenances: provenances,
                      updatedAdresseLivInfo: updatedAdresseLivInfo,
                      updatedAdresseFactInfo: updatedAdresseFactInfo,
                      updatedFinalAdresseLivInfo: updatedFinalAdresseLivInfo,
                      updatedFinalAdresseFactInfo: updatedFinalAdresseFactInfo,
                      isAdresseUpdated: isAdresseUpdated,
                      adresseFacturation: adresseFacturation,
                      errorsFac: errorsFac,
                      errorsLiv: errorsLiv,
                      requierdFieldFac: requierdFieldFac,
                      requierdFieldLiv: requierdFieldLiv,
                      contactedByBloc: contactedByBloc,
                      contentCommunication: contactedByBloc,
                      tauxRemise: dataClientInfos?.tauxRemise ?? 0,
                      searchTerm: searchTerm,
                      clientDemandeStatus: clientDemandeStatus,
                      retraitDepot: retraitDepot,
                      commentaireInterne: commentaireInterne,
                      selectedSite: selectedSite,
                      imagesDemandePj: imagesDemandePj,
                    }}
                  >
                    <i className='ki-duotone ki-magnifier fs-2'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                    Recherche stock
                  </Link>
                )}

                <div>
                  {isAssign && (
                    <ShopModal
                      clientId={params?.clientId}
                      demandeId={params?.demandId}
                      setPiecesProps={setPiecesProps}
                      panier={panier}
                      setPanier={setPanier}
                      panierFiltered={handlePanierFiltered}
                      redirectToClientDemande={redirectToClientDemande}
                      demandeClient={demandeClient}
                      setDemandeClient={setDemandeClient}
                      loading={loading}
                      pieces={pieces}
                      setPieces={setPieces}
                      dataClientInfos={dataClientInfos}
                      otherData={otherData}
                      loadingCLientInfo={loadingCLientInfo}
                      isProspect={isProspect}
                      totalPanier={panier.length}
                      selectedPiecesFromVehicle={selectedPiecesFromVehicle}
                      filters={filters}
                      fromListePiece={fromListePiece}
                      setFromListePiece={setFromListePiece}
                      panierByStatus={panierByStatus}
                      setPanierByStatus={setPanierByStatus}
                      provenances={provenances}
                      isAdresseUpdated={isAdresseUpdated}
                      setIsAdresseUpdated={setIsAdresseUpdated}
                      updatedFinalAdresseLivInfo={updatedFinalAdresseLivInfo}
                      setUpdatedFinalAdresseLivInfo={setUpdatedFinalAdresseLivInfo}
                      updatedFinalAdresseFactInfo={updatedFinalAdresseFactInfo}
                      setUpdatedFinalAdresseFactInfo={setUpdatedFinalAdresseFactInfo}
                      adresseFacturation={adresseFacturation}
                      errorsFac={errorsFac}
                      setErrorsFac={setErrorsFac}
                      errorsLiv={errorsLiv}
                      setErrorsLIv={setErrorsLIv}
                      requierdFieldFac={requierdFieldFac}
                      requierdFieldLiv={requierdFieldLiv}
                      clientAdressesFacLiv={clientAdresses}
                      setIsEdit={setIsEdit}
                      contactedByBloc={contactedByBloc}
                      setContactedByBloc={setContactedByBloc}
                      clientDemandeStatus={clientDemandeStatus}
                      piecePropData={piecePropData}
                      refetchClientAdresses={refetchClientAdresses}
                      retraitDepot={retraitDepot}
                      setRetraitDepot={setRetraitDepot}
                      initialPieces={initialPieces}
                      setInitialPieces={setInitialPieces}
                      totalLibelle={totalLibelle}
                      setTotalLibelle={setTotalLibelle}
                      getAdresseRetraitDepot={getAdresseRetraitDepot}
                      loadingDepot={loadingDepot}
                      setSelectedDepotsByPiece={setSelectedDepotsByPiece}
                      adresseDepots={adresseDepots}
                      commentaireInterne={commentaireInterne}
                      setCommentaireInterne={setCommentaireInterne}
                      sourceDevis={sourceDevis}
                      setIsEditPanier={setIsEditPanier}
                      livraisonSelectedValue={livraisonSelectedValue}
                      setLivraisonSelectedValue={setLivraisonSelectedValue}
                      facturationSelectedValue={facturationSelectedValue}
                      setFacturationSelectedValue={setFacturationSelectedValue}
                      clientAdresseData={clientAdresseData}
                      clientContacts={clientContacts}
                      getDemandeProp={getDemandeProp}
                      setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
                      setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <div>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-150px fs-6'>Référence pièce</th>
                  <th className='min-w-150px fs-6'>Immatriculation</th>
                  <th className='min-w-150px fs-6'>Marque / Modèle</th>
                  <th className='min-w-120px fs-6'>Commentaire</th>
                  <th className='min-w-120px fs-6'>Référence OE</th>
                  <th className='min-w-80px fs-6'>Quantité</th>
                  <th className='min-w-100px fs-6'>Statut</th>
                  <th className='min-w-50px fs-6'>Stock</th>
                </tr>
              </thead>
              <tbody>{pieces.length > 0 && renderFormRowPieces()}</tbody>
            </table>
          </div>
        </div>
      </div>
      {/*Affichage du tooltip*/}
      <Tooltip id='tooltip' />
      {/*<CommentaireClientDemande idClientDemande={demandeId} clientId={params?.clientId} />*/}
      <ModalPOT
        piece={selectedPOTAriane}
        showToastPOT={showToastPOT}
        piecesProps={piecesProps}
        setPiecesProps={setPiecesProps}
        // panier={panier}
        setPanier={setPanier}
        // allPieces={pieces}
        setAllPieces={setPieces}
        dataClientInfos={dataClientInfos}
        provenances={provenances}
        isEdit={true}
        setDemandeClient={setDemandeClient}
        isEditPanier={isEditPanier}
        setIsEditPanier={setIsEditPanier}
      />
    </>
  )
}
export {ListePiece}
